import { utils } from '../../Foundation';

export class DatatableHeader {
    constructor(inputSettings) {
        this._refs = {
            el: inputSettings.el,
            table: inputSettings.table,
            state: {
                data: inputSettings.state.data,
            },
            customLabels: inputSettings.customLabels,
            eventList: inputSettings.eventList
        }

        this._createTableHeader();
    }

    async _createTableHeader() {
        // Check if table header exist
        const isHeaderCreated = this._refs.table.querySelector('thead');
        if(!isHeaderCreated && this._refs.state.data.length > 0) {
            // Fetch table header labels
            const listOfLabels = this._fetchTableHeaderLabels();
            // Create header labels
            const theadElement = utils.createElement('thead', {});
            const trElement = utils.createElement('tr', {
                'class': 'datatable__header d-flex'
            }, theadElement);
            await listOfLabels.forEach((label, i) => {
                if(typeof this._refs.eventList.customHeader === 'function') {
                    this._refs.eventList.customHeader(trElement, label, i);
                } else {
                    const textLabel = utils.createElement('th', {
                        'class': 'datatable__cell font-bold'
                    }, trElement);
                    utils.createElement('span', {
                        'innerText': label
                    }, textLabel);
                }
            });
            this._refs.table.append(theadElement);
        };
    }

    _fetchTableHeaderLabels() {
        // Check if Custom header should be used
        if(this._refs.customLabels) {
            if(this._refs.customLabels.length > 0) {
                return this._refs.customLabels;
            }
        }
        // Else use default header from the object
        const listOfLabels = Object.keys(this._refs.state.data[0]);
        return listOfLabels;
    }
}